import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { testimonials } from '../../data/testimonials';
function Stars() {
  return <span className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-324" data-mp="3mf7r0j7onsd3">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-325" data-mp="3r9lqawpgujn1" data-mpi={i} />)}
    </span>;
}
export function Testimonials() {
  return <section className="bg-paper px-4 py-16 sm:py-20" data-id="element-326" data-mp="41rrb5p0s369">
      <div className="mx-auto max-w-5xl" data-id="element-327" data-mp="44nm4l5kmbqh">
        <SectionHeading title="What other reflexology students are saying" data-id="element-328" data-mp="92xkf4mldsgb" />
        <div className="mt-5 flex items-center justify-center gap-3" data-id="element-329" data-mp="e1ilt7dkyi6c">
          <Stars data-id="element-330" data-mp="dymp1mdgxzjh" />
          <span className="font-serif text-2xl font-bold text-forest" data-id="element-331" data-mp="2atiq88vr7khc">4.9/5</span>
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-332" data-mp="2fs3sseyhag8y">
          {testimonials.map((t, i) => <li key={i} className="flex flex-col rounded-3xl bg-cream p-5" data-id="element-333" data-mp="1sl2odziug025" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-334" data-mp="1ntszx29172ru">
                <img src={t.photo} alt={`Photo of ${t.name}`} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-paper" loading="lazy" data-id="element-335" data-mp="1ns9i377q8jny" />
                <div className="min-w-0" data-id="element-336" data-mp="1etebhu0rt7k4">
                  <p className="font-bold text-ink" data-id="element-337" data-mp="1eupevsqb0dap">{t.name}</p>
                  <p className="flex items-center gap-1 text-sm text-muted" data-id="element-338" data-mp="2bjx0t1uu4of5">
                    <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-339" data-mp="26kan6rb3h65t" />
                    {t.country}
                  </p>
                </div>
              </div>
              <div className="mt-4" data-id="element-340" data-mp="22gvxf8xctbf6"><Stars data-id="element-341" data-mp="22kjn1wzohdom" /></div>
              <blockquote className="mt-3 text-base leading-relaxed text-ink/85" data-id="element-342" data-mp="1xk5jar540pwe">“{t.quote}”</blockquote>
            </li>)}
        </ul>

        <div className="mt-10" data-id="element-343" data-mp="r4v4rixdd2u5">
          <CTAButton label="Yes! I want to start my 21 days" note="Instant access · One-time payment of $27" data-id="element-344" data-mp="m4gwbzruvqvl" />
        </div>
      </div>
    </section>;
}